var _polygon, _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgInvoice = function SvgInvoice(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 30,
    viewBox: "0 0 22 30",
    fill: "currentColor",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "16 0 16 6 22 6 16 0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21,8H20V1H5V31H27V8ZM6.89978,8.15912H7.658V7.95618c0-.17646.01379-.35181.02759-.50177H6.89978V6.61505H7.8075A4.16536,4.16536,0,0,1,8.82324,4.55591a3.8421,3.8421,0,0,1,2.92548-1.25952,4.5127,4.5127,0,0,1,1.93732.42022l-.33863,1.24628a3.52252,3.52252,0,0,0-1.517-.3529,2.22726,2.22726,0,0,0-1.72058.74554,2.60575,2.60575,0,0,0-.59613,1.25952h3.5492v.83936H9.35156a2.80508,2.80508,0,0,0-.027.48858v.21613h3.73835v.83935H9.47345a2.46683,2.46683,0,0,0,.58234,1.31464,2.40069,2.40069,0,0,0,1.81482.73126,3.71641,3.71641,0,0,0,1.59869-.39264l.28455,1.20545a4.17572,4.17572,0,0,1-2.07294.54156,3.82319,3.82319,0,0,1-3.06116-1.3952,3.88267,3.88267,0,0,1-.85309-2.00507H6.89978ZM15,28H7V27h8Zm10-2H7V25H25Zm0-2H7V23H25Zm0-2H7V21H25Zm0-2H7V19H25Zm0-2H7V17H25Zm0-2H7V15H25Z",
    transform: "translate(-5 -1)"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInvoice, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/invoice.b158ef47.svg";
export { ForwardRef as ReactComponent };